"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iconBubble = exports.checkableButton = exports.buttonThemes = exports.baseButton = exports.fitTextPadding = exports.clickable = exports.buttonColorThemes = void 0;

var _styledComponents = require("styled-components");

var _baseColorThemes = _interopRequireDefault(require("./baseColorThemes"));

var _helperFunctions = require("../helperFunctions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var buttonColorThemes = [].concat(_toConsumableArray(_baseColorThemes.default), ['primaryGhost', 'primaryPseudo', 'primaryLight', 'ctaGhost', 'infoGhost', 'dangerGhost', 'dangerPseudo', 'disabled']); // All clickable things, regardless of type should:
// - Be in the secondary font (Nunito)
// - Utilize the 'pointer' cursor

exports.buttonColorThemes = buttonColorThemes;
var clickable = (0, _styledComponents.css)(["font-weight:", ";outline:none;&,& *{font-family:", ";letter-spacing:", ";cursor:pointer;}"], function (props) {
  return props.theme.secondaryHeavy;
}, function (props) {
  return props.theme.secondaryFont;
}, function (props) {
  return props.theme.boldOverDarkSpacing;
});
exports.clickable = clickable;
var fitTextPadding = (0, _styledComponents.css)(["", ""], function (props) {
  return (0, _helperFunctions.joinDimensions)('*', 1.5, props.theme.standardPadding);
});
exports.fitTextPadding = fitTextPadding;
var baseButton = (0, _styledComponents.css)(["align-items:center;border-radius:", ";display:inline-flex;justify-content:center;line-height:1;", ";border:", ";margin:", " 0;", ";&.c-button-disabled,&:disabled,&.c-button-disabled:hover,&:disabled:hover{&,& *{background-color:", ";color:", ";cursor:not-allowed;font-weight:", ";}& svg *{opacity:.5;}border-color:", ";box-shadow:none;}"], function (props) {
  return props.theme.borderRadiusButton;
}, function (props) {
  switch (props.buttonHeight) {
    case 'small':
      // half-baked
      return "\n          min-height: ".concat(props.theme.smallButtonHeight, ";\n          font-size: ").concat(props.theme.fontSmall, ";\n          padding: .1rem .3rem;\n        ");

    case 'medium':
      // half-baked
      return "\n          min-height: ".concat(props.theme.mediumButtonHeight, ";\n          font-size: ").concat(props.theme.fontMedium, ";\n          padding: .25rem .75rem;\n        ");

    case 'large':
    default:
      return "\n        min-height: ".concat(props.theme.standardButtonHeight, ";\n        font-size: ").concat(props.theme.fontMedium, ";\n        padding: .5rem 1.5rem;\n      ");
  }
}, function (props) {
  return "".concat(props.theme.b_button, " transparent");
}, function (props) {
  return props.theme.standardPadding;
}, function (props) {
  switch (props.buttonWidth) {
    case 'fitText':
      return (0, _styledComponents.css)(["min-width:min-content;width:min-content;white-space:nowrap;padding:0 ", ";"], fitTextPadding);

    case 'small':
      return "\n          min-width: ".concat(props.theme.component_small, ";\n          width: ").concat(props.theme.component_small, ";\n        ");

    case 'medium':
      return "\n          min-width: ".concat(props.theme.component_medium, ";\n          width: ").concat(props.theme.component_medium, ";\n        ");

    case 'large':
      return "\n          min-width: ".concat(props.theme.component_large, ";\n          width: ").concat(props.theme.component_large, ";\n        ");

    default:
      return 'width: 100%';
  }
}, function (props) {
  return props.theme.c_clickable_disabled_background;
}, function (props) {
  return props.theme.c_clickable_disabled_text;
}, function (props) {
  return props.theme.secondaryNormal;
}, function (props) {
  return props.theme.c_clickable_disabled_border;
});
exports.baseButton = baseButton;
var buttonThemes = (0, _styledComponents.css)(["&,& *{background-color:", ";color:", ";}border-color:", ";&.c-button-active:hover,&:hover{&,& *{background-color:", ";color:", ";}border-color:", ";}&:active,&.c-button-active{&,& *{background-color:", ";color:", ";}border-color:", ";}"], function (props) {
  return props.theme["c_clickable_".concat(props.colorTheme, "_background")];
}, function (props) {
  return props.theme["c_clickable_".concat(props.colorTheme, "_text")];
}, function (props) {
  return props.theme["c_clickable_".concat(props.colorTheme, "_border")];
}, function (props) {
  return props.theme["c_clickable_".concat(props.colorTheme, "_hover_background")];
}, function (props) {
  return props.theme["c_clickable_".concat(props.colorTheme, "_hover_text")];
}, function (props) {
  return props.theme["c_clickable_".concat(props.colorTheme, "_hover_border")];
}, function (props) {
  return props.theme["c_clickable_".concat(props.colorTheme, "_active_background")];
}, function (props) {
  return props.theme["c_clickable_".concat(props.colorTheme, "_active_text")];
}, function (props) {
  return props.theme["c_clickable_".concat(props.colorTheme, "_active_border")];
}); // checkable button only has one color theme, which matches primaryGhost
// our linting rules force this ugly as sin format - someday i may try to do something about it

exports.buttonThemes = buttonThemes;
var checkableButton = (0, _styledComponents.css)(["align-items:center;border-radius:", ";border:", ";display:flex;flex-flow:row nowrap;font-size:1.25rem;margin:", " 0;min-height:", ";min-width:9rem;padding:0 ", ";width:100%;border-color:", ";&,& *{background-color:", ";color:", ";}&:hover{&,& *{background-color:", ";}&,& *{border-color:", ";}&,& *{color:", ";}}&:active{&,& *{background-color:", ";}&,& *{border-color:", ";}&,& *{color:", ";}}"], function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return "".concat(props.theme.b_button, " transparent");
}, function (props) {
  return props.theme.standardPadding;
}, function (props) {
  return props.theme.standardButtonHeight;
}, function (props) {
  return props.theme.standardPadding;
}, function (props) {
  return props.checked ? props.theme.c_clickable_checkboxChecked_border : props.theme.c_clickable_checkbox_border;
}, function (props) {
  return props.checked ? props.theme.c_clickable_checkboxChecked_background : props.theme.c_clickable_checkbox_background;
}, function (props) {
  return props.checked ? props.theme.c_clickable_checkboxChecked_text : props.theme.c_clickable_checkbox_text;
}, function (props) {
  return props.checked ? props.theme.c_clickable_checkboxChecked_hover_background : props.theme.c_clickable_checkbox_hover_background;
}, function (props) {
  return props.checked ? props.theme.c_clickable_checkboxChecked_hover_border : props.theme.c_clickable_checkbox_hover_border;
}, function (props) {
  return props.checked ? props.theme.c_clickable_checkboxChecked_hover_text : props.theme.c_clickable_checkbox_hover_text;
}, function (props) {
  return props.checked ? props.theme.c_clickable_checkboxChecked_active_background : props.theme.c_clickable_checkbox_active_background;
}, function (props) {
  return props.checked ? props.theme.c_clickable_checkboxChecked_active_border : props.theme.c_clickable_checkbox_active_border;
}, function (props) {
  return props.checked ? props.theme.c_clickable_checkboxChecked_active_text : props.theme.c_clickable_checkbox_active_text;
}); // this thing appears 'button-like', thus its inclusion here

exports.checkableButton = checkableButton;
var iconBubble = (0, _styledComponents.css)(["display:inline-flex;height:", ";justify-content:center;min-width:", ";padding:0;vertical-align:middle;width:", ";", ";&,& *{letter-spacing:normal;}"], function (props) {
  return props.theme.standardButtonHeight;
}, function (props) {
  return props.theme.standardButtonHeight;
}, function (props) {
  return props.theme.standardButtonHeight;
}, function (props) {
  switch (props.buttonHeight) {
    case 'small':
      // half-baked
      return "height: ".concat(props.theme.smallButtonHeight, ";\n          min-height: ").concat(props.theme.smallButtonHeight, ";\n          width: ").concat(props.theme.smallButtonHeight, ";\n          min-width: ").concat(props.theme.smallButtonHeight, ";\n          & * {\n            font-size: ").concat(props.theme.fontSmall, ";\n            min-width: ").concat(props.theme.fontSmall, ";\n            min-height: ").concat(props.theme.fontSmall, ";\n          }");

    case 'medium':
      // half-baked
      return "min-height: ".concat(props.theme.mediumButtonHeight, ";\n          width: ").concat(props.theme.mediumButtonHeight, ";\n          min-width: ").concat(props.theme.mediumButtonHeight, ";\n          &, & * {\n            font-size: 1rem;\n          }");

    case 'large':
    default:
      return "min-height: ".concat(props.theme.standardButtonHeight, ";\n          width: ").concat(props.theme.standardButtonHeight, ";\n          min-width: ").concat(props.theme.standardButtonHeight, ";\n          &, & * {\n            font-size: ").concat(props.theme.fontMedium, ";\n          }");
  }
});
exports.iconBubble = iconBubble;